import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqFileService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/cq-files', query);
  }

  create(body: any) {
    return this.post('/cq-files', body);
  }

  reanalysis(body: any) {
    // console.log(body);
    return this.post('/cq-files-reanalysis', body);
  }

  find(id) {
    return this.get('/cq-files/' + id);
  }

  update(id, body) {
    return this.put('/cq-files/' + id, body);
  }

  _delete(id) {
    return this.delete('/cq-files/' + id);
  }

  deleteMany(body) {
    return this.post('/cq-files-delemany', body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqFile.service.ts